module.exports = __webpack_public_path__ + "img/0101.d7afe458.png";